(() => {
  // Handler when the DOM is fully loaded
  const callback = function () {
    if (document.querySelector(".mainpro-info")) {
      function featureSlidermainpro() {
        const $featureSlider = $(".mainpro-info").slick({
          infinite: false,
          slidesToShow: 2.25,
          dots: false,
          nextArrow:
            '<span class="slick-next slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
          prevArrow:
            '<span class="slick-prev slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                dots: true,
              },
            },
          ],
        });
        $(".mainpro-info").css("opacity", "1");

        if (window.innerWidth <= 800) {
          const dot_list = $featureSlider.find(".slick-dots")[0];
          dot_list.querySelectorAll("li").forEach((el, i) => {
            el.insertAdjacentHTML(
              "afterend",
              `<li class="${
                i == 0 ? "slick-active" : ""
              }" data-index="${i}" ><button type="button">${i}</button></li>`
            );
            el.remove();
          });
          dot_list.querySelectorAll("li").forEach((el) => {
            el.addEventListener("click", (e) => {
              console.log(e.currentTarget.dataset.index);
              $featureSlider.slick(
                "slickGoTo",
                parseInt(e.currentTarget.dataset.index)
              );
            });
          });
        }
      }
      featureSlidermainpro();
    }
  };
  if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
  ) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
})();
